export default "__VITE_ASSET__DmdhKKTW__"